import jQuery from "jquery";

import eventBus from '@/shared/event-bus';

class LazyImages {
    constructor() {
        this.scriptAdded = false;
        this.init();

        if (typeof jQuery !== 'undefined') {
            jQuery(document).ajaxComplete(() => {
                console.info('AJAX request completed, initializing lazy images...');
                this.init();
            });
        }

        eventBus.on('dynamicContentLoaded', () => {
            this.init();
        });
    }

    init() {
        const lazyImages = document.querySelectorAll('img.lazyload');

        if (lazyImages.length > 0) {
            if ('loading' in HTMLImageElement.prototype) {
                for (let i = 0; i < lazyImages.length; i++) {
                    if (!lazyImages[i].src) {
                        lazyImages[i].src = lazyImages[i].dataset.src;
                    }
                }
            } else {
                if (!this.scriptAdded) {
                    this.includeScript();
                    this.scriptAdded = true;
                }
            }
        }
    }

    includeScript() {
        // Dynamically import the LazySizes library
        import('lazysizes');
    }
}

new LazyImages();
